import $x from '@/utils/$x';

/**  商家管理 **/

/// 商家管理首页
export async function queryManagerList(params) {
  return $x.post('/tenant/manager/pageList', params);
}

/// 新建商家
export async function addTenant(params) {
  return $x.post('/tenant/manager/addTenant', params);
}

/// 商家审核
export async function tenantAuditing(params) {
  return $x.post('/tenant/manager/tenantAuditing', params);
}

/// 商家基础信息编辑
export async function tenantBaseInfoModify(params) {
  return $x.post('/tenant/manager/tenantBaseInfoModify', params);
}

/// 商家结算信息编辑
export async function tenantSettleModify(params) {
  return $x.post('/tenant/manager/tenantSettleModify', params);
}
/// 商家培训信息编辑
export async function tenantTrainInfoModify(params) {
  return $x.post('/tenant/manager/tenantTrainInfoModify', params);
}
/// 查询商家信息
export async function queryTenant(params) {
  return $x.post('/tenant/manager/queryTenant', params);
}
/// 删除商家信息
export async function deleteTenant(params) {
  return $x.post('/tenant/manager/deleteTenant', params);
}
/// 商家等级下拉列表
export async function gradeList(params) {
  return $x.post('/tenant/grade/list-all', params);
}
/// 保证金流水列表
export async function pageMarginTrade(params) {
  return $x.post('/tenant/manager/pageMarginTrade', params);
}
/// 导出保证金流水列表
export async function exportSettlmentData(params) {
  return $x.post('/margin/account/export', params);
}
/// 保证金扣除
export async function marginAccountTrade(params) {
  return $x.post('/tenant/manager/marginAccountTrade', params);
}
/// 查询商家子账号和管理员列表
export async function tenantOperationalUser(params) {
  return $x.post('/tenant/manager/tenantOperationalUser', params);
}
/// 创建 or 更新二级调度
export async function createOrUpdateExtraSchedule(params) {
  return $x.post('/tenant/manager/createOrUpdateExtraSchedule', params);
}
/// 删除二级调度
export async function deleteExtraSchedule(params) {
  return $x.post('/tenant/manager/deleteExtraSchedule', params);
}
/// 商家流量分配
export async function trafficDistributes(params) {
  return $x.post('/tenant/manager/trafficDistributes', params);
}
/// 商家流量分配
export async function trafficDistributesManager(params) {
  return $x.post('/tenant/manager/trafficDistributesManager', params);
}
/// 商家流量分配
export async function distributesDetail(params) {
  return $x.post('/tenant/manager/distributesDetail', params);
}

/// 会员一对多
export async function setMultiTenant(params) {
  return $x.post('/tenant/manager/setMultiTenant', params);
}

/**  账号成员 **/

/// 用户列表查询
export async function getUserList(params) {
  return $x.post('/tenant/user/list', params);
}

/// 用户 启用和删除 更新
export async function userUpdate(params) {
  return $x.post('/tenant/user/update', params);
}
/// 用户添加
export async function userAdd(params) {
  return $x.post('/tenant/user/add', params);
}
/// 用户 USERID 获取
export async function getUserId(params) {
  return $x.post('/tenant/user/getUserId', params);
}

/// 绑定用户列表
export async function getBindUserList(params) {
  return $x.post('/tenant/user/userlist', params);
}

/// 绑定用户
export async function bindUser(params) {
  return $x.post('/tenant/user/bind/add', params);
}

/// 绑定用户
export async function bindUserBtob(params) {
  return $x.post('/tenant/user/bind/btob', params);
}

/**  商家等级 **/

/// 商家列表
export async function getmerchantList(params) {
  return $x.post('/tenant/manager/listTenant', params);
}

/// 商家列表
export async function pageTenantSimple(params) {
  return $x.post('/tenant/manager/pageTenantSimple', params);
}

// 客户换绑记录
export async function changBindingRecord(params) {
  return $x.post('/tenant/manager/changBindingRecord', params);
}
// 客户换绑记录
export async function choseUser(params) {
  return $x.post('/tenant/manager/choseUser', params);
}
// 商家员工列表
export async function tenantUser(params) {
  return $x.post('/tenant/manager/tenantUser', params);
}
// 商家员工列表
export async function changBinding(params) {
  return $x.post('/tenant/manager/changBinding', params);
}

// 根据角色类型查询商家等级下拉列表
export async function listByType(params) {
  return $x.post('/tenant/grade/listByType', params);
}

// 合伙人管理-&gt;绑定商家-&gt;参与GMV提成开关
export async function gmvCommissionSwitch(params) {
  return $x.post('/partner/manager/gmvCommissionSwitch', params);
}

// 设置 是否参与结算
export async function setSettlement(params) {
  return $x.post('/tenant/manager/setSettlement', params);
}

/**
 * 设置解锁能力
 * @param {*} params
 * @returns
 */
export async function setCustomAbility(params) {
  return $x.post('/tenant/manager/setCustomAbility', params);
}

/**
 *  枚举值
 * @param {*} params
 * @returns
 */
export async function getMerchanCreatEnums(params) {
  return $x.post('/tenant/manager/enums', params);
}

/**
 *  修改绑定方式
 * @param {*} params
 * @returns
 */
export async function updateBindUserType(params) {
  return $x.post('/tenant/user/update/type', params);
}

/**
 *  商户列表
 * @param {*} params
 * @returns
 */
export async function getALiAccountList(params) {
  return $x.post('/pay/card/sign/list', params);
}
/**
 *  添加商户
 * @param {*} params
 * @returns
 */
export async function addAliAccount(params) {
  return $x.post('/pay/card/sign/add', params);
}
/**
 *  更新商户
 * @param {*} params
 * @returns
 */
export async function updateAliAccount(params) {
  return $x.post('/pay/card/sign/update', params);
}
/**
 *  商户签约地址
 * @param {*} params
 * @returns
 */
export async function getSignCodeAliAccount(params) {
  return $x.post('/pay/card/sign/code', params);
}
/**
 *  更新商家状态
 * @param {*} params
 * @returns
 */
export async function statusAliAccount(params) {
  return $x.post('/pay/card/sign/update/status', params);
}
/**
 *  获取商家列表
 * @param {*} params
 * @returns
 */
export async function getMerchantListAliAccount(params) {
  return $x.post('/pay/card/sign/merchant/list', params);
}
/**
 *  添加充值
 * @param {*} params
 * @returns
 */
export async function addRechargeAliAccount(params) {
  return $x.post('/pay/card/recharge/add', params);
}
/**
 *  充值列表
 * @param {*} params
 * @returns
 */
export async function getRechargeAliAccount(params) {
  return $x.post('/pay/card/recharge/list', params);
}
/**
 *  充值链接
 * @param {*} params
 * @returns
 */
export async function getRechargeCodeAliAccount(params) {
  return $x.post('/pay/card/recharge/code', params);
}
/**
 *  新建对账单
 * @param {*} params
 * @returns
 */
export async function addBillSettlement(params) {
  return $x.post('/pay/card/bill/add', params);
}
/**
 *  审核对账单
 * @param {*} params
 * @returns
 */
export async function auditBillSettlement(params) {
  return $x.post('/pay/card/bill/audit', params);
}
/**
 *  作废
 * @param {*} params
 * @returns
 */
export async function voidBillSettlement(params) {
  return $x.post('/pay/card/bill/void', params);
}
/**
 *  对账单列表
 * @param {*} params
 * @returns
 */
export async function getBillLitsSettlement(params) {
  return $x.post('/pay/card/bill/list', params);
}
/**
 *  待支付列表
 * @param {*} params
 * @returns
 */
export async function getPaymentSettlement(params) {
  return $x.post('/pay/card/payment/list', params);
}
/**
 *  审待支付失败列表
 * @param {*} params
 * @returns
 */
export async function getPaymentFailSettlement(params) {
  return $x.post('/pay/card/payment/fail/list', params);
}
/**
 *  钱包
 * @param {*} params
 * @returns
 */
export async function getPurseList(params) {
  return $x.post('/pay/card/purse/list', params);
}
/**
 *  下载
 * @param {*} params
 * @returns
 */
export async function exportSettlement(params) {
  return $x.post('/pay/card/payment/list/export', params);
}
/**
 *  转账列表
 * @param {*} params
 * @returns
 */
export async function getTransferList(params) {
  return $x.post('/pay/card/transfer/list', params);
}
/**
 *  新增转账
 * @param {*} params
 * @returns
 */
export async function addTransfer(params) {
  return $x.post('/pay/card/transfer/add', params);
}
/**
 *  提交转账
 * @param {*} params
 * @returns
 */
export async function submitTransfer(params) {
  return $x.post('/pay/card/transfer/submit', params);
}
/**
 *  作废转账
 * @param {*} params
 * @returns
 */
export async function deleteTransfer(params) {
  return $x.post('/pay/card/transfer/delete', params);
}

/**
 *  支付路由设置
 * @param {*} params
 * @returns
 */
export async function setPayRoute(params) {
  return $x.post('/pay/card/sign/default_chose', params);
}

/**
 *  支付路由查询
 * @param {*} params
 * @returns
 */
export async function getPayRoute(params) {
  return $x.post('/pay/card/sign/default_chose/info', params);
}

/**
 *  查询路由配置
 * @param {*} params
 * @returns
 */
export async function getPaymentRoute(params) {
  return $x.post('/coach/statement/payment-route/get', params);
}

/**
 *  更新路由配置
 * @param {*} params
 * @returns
 */
export async function updatePaymentRoute(params) {
  return $x.post('/coach/statement/payment-route/update', params);
}

/**
 *  KYB文件列表
 * @param {*} params
 * @returns
 */
export async function getKybFileList(params) {
  return $x.post('/pay/card/kyb/files/page', params);
}
/**
 *  新增KYB文件
 * @param {*} params
 * @returns
 */
export async function addKybFile(params) {
  return $x.post('/pay/card/kyb/files/add', params);
}
/**
 *  更新KYB文件
 * @param {*} params
 * @returns
 */
export async function updateKybFile(params) {
  return $x.post('/pay/card/kyb/files/update', params);
}
/**
 *  KYB申请详情
 * @param {*} params
 * @returns
 */
export async function KybApplyDetail(params) {
  return $x.post('/pay/card/kyb/apply/detail', params);
}
/**
 *  KYB申请
 * @param {*} params
 * @returns
 */
export async function KybApply(params) {
  return $x.post('/pay/card/kyb/apply', params);
}
/**
 *  KYB申请查询
 * @param {*} params
 * @returns
 */
export async function KybApplyQuery(params) {
  return $x.post('/pay/card/kyb/apply/query', params);
}
/**
 *  KYB申请取消
 * @param {*} params
 * @returns
 */
export async function KybApplyCancel(params) {
  return $x.post('/pay/card/kyb/apply/cancel', params);
}
/**
 *  查询关联主体
 * @param {*} params
 * @returns
 */
export async function getEnterprisePage(params) {
  return $x.post('/enterprise/page', params);
}
/**
 *  获取商家配置列表
 * @param {*} params
 * @returns
 */
export async function getMerchantPromptList(params) {
  return $x.post('/prompt/manager/list', params);
}
/**
 *  获取商家配置类型
 * @param {*} params
 * @returns
 */
export async function getMerchantPromptType(params) {
  return $x.post('/prompt/manager/type', params);
}
/**
 *  保存商家配置
 * @param {*} params
 * @returns
 */
export async function saveMerchantPrompt(params) {
  return $x.post('/prompt/manager/save', params);
}
